<template>
  <div class="terms-page">
    <section class="terms-profile">
      <div class="container">
        <div class="content">
          <div class="head">
            <Button :to="{ path: '/' }" class="white left" arrow="left"
              >Főoldal</Button
            >
          </div>
          <div class="title">
            <h2 class="h1">Általános Szerződési Feltételek</h2>
          </div>
          <div class="text">
            <h3 class="h3">Feltételek</h3>
            <p>
              Kiadó irodák hiánypótló, “A” kategóriájú irodaházban, amely
              csakúgy megad mindent bérlőinek mint a belvárosi irodák, ráadásul
              gyönyörű, zöldövezeti környezetben helyezkedik el. Mindegyik iroda
              hatalmas ablakokkal felszerelt, így rengeteg a természetes fény és
              gyönyörű kilátás nyílik a környező kertre és erdőre.
            </p>
          </div>
          <div class="text">
            <h3 class="h3">1 Impresszum - Üzemeltetői adatok</h3>
            <p>
              Név: ASDFG Korlátolt Felelősségű Társaság <br />
              Székhely: 1122 Budapest, Bíró u. 11. fszt. 1<br />
              Postacím: 1122 Budapest, Bíró u. 11. fszt. 1.<br />
              Nyilvántartásba vevő hatóság: Fővárosi Törvényszék<br />
              Cégbírósága Cégjegyzékszám: 01-09-160811 <br />
              Adószám: 10639865-2-43<br />
              Képviselő: Dr. Varga Péter Pál ügyvezető<br />
              E-mail: email@email.hu<br />
              Honlap: www.offie.hu<br />
              <br />
              Tárhelyszolgáltató adatai: <br />
              <br />
              ArtMagister Kft. <br />
              Cégjegyzékszám: 01-09-176060<br />
              Adószám: 24662930-2-43 <br />
              Székhely: 1213 Budapest, Kórus utca 38. <br />
              <br />
              Elérhetőség: info@artmagister.hu
            </p>
          </div>
          <div class="text">
            <h3 class="h3">
              2 Alapvető rendelkezések
            </h3>
            <p>
              2.1. A jelen ÁSZF-ben nem szabályozott kérdésekre, valamint jelen
              ÁSZF értelmezésére a magyar jog az irányadó, különös tekintettel a
              Polgári Törvénykönyvről szóló 2013. évi V. törvény („Ptk.”) és az
              elektronikus kereskedelmi szolgáltatások, valamint az információs
              társadalommal összefüggő szolgáltatások egyes kérdéseiről szóló
              2001. évi CVIII. (Elker. tv.) törvény vonatkozó rendelkezéseire. A
              vonatkozó jogszabályok kötelező rendelkezései a felekre külön
              kikötés nélkül is irányadók.
            </p>
            <p>
              2.2. A jelen ÁSZF 2022.05.02. napjától hatályos és visszavonásig
              hatályban marad. A Társaság jogosult egyoldalúan módosítani a
              ÁSZF-t. A módosításokat a Társaság azok hatályba lépése előtt 11
              (tizenegy) nappal a weboldalakon közzéteszi. Megrendelők a
              weboldalak használatával elfogadják, hogy rájuk nézve a weboldalak
              használatával kapcsolatos valamennyi szabályozás automatikusan
              érvényes.
            </p>
            <p>
              2.3. Megrendelő, amennyiben belép a Társaság által üzemeltetett
              webshop weboldalra, vagy annak tartalmát bármilyen módon olvassa -
              akkor is, ha nem regisztrált Megrendelője a webshopnak, a ÁSZFban
              foglaltakat magára nézve kötelezőnek ismeri el. Amennyiben a
              Megrendelő nem fogadja el a feltételeket, nem jogosult a webshop
              tartalmának megtekintésére.
            </p>
            <p>
              2.4. Társaság fenntart magának minden jogot a webshop weboldal,
              annak bármely részlete és az azon megjelenő tartalmak, valamint a
              weboldal terjesztésének tekintetében. Tilos a webshopon megjelenő
              tartalmak vagy azok bármely részletének letöltése, elektronikus
              tárolása, feldolgozása és értékesítése a Társaság írásos
              hozzájárulása nélkül.
            </p>
          </div>
          <div class="text">
            <h3 class="h3"></h3>
            <p></p>
          </div>
          <div class="text">
            <h3 class="h3"></h3>
            <p></p>
          </div>
          <div class="text">
            <h3 class="h3"></h3>
            <p></p>
          </div>
          <div class="text">
            <h3 class="h3"></h3>
            <p></p>
          </div>

          <div class="control">
            <Button
              :to="{ path: '#kapcsolat' }"
              @click="next(this, event)"
              class="black"
              arrow="right"
              >Kapcsolat</Button
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

export default {
  name: "Terms",
  components: {
    Button
  },
  data() {
    return {
      full: false,
      fullsrc: false,
      hasPrev: false,
      hasNext: true
    };
  },
  methods: {}
};
</script>

<style lang="scss">
.terms-page {
  background: $white;
  display: flex;
  flex-direction: column;

  .fullscreen {
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $black;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    &.opened {
      z-index: 1000;
      opacity: 1;
    }
    picture {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
.terms-profile {
  padding: 0 0 54px !important;
  background: $background;
  display: block;
  width: 100%;
  .container {
    .content {
      display: flex;
      flex-direction: column;
      .head {
        padding: 0 16px;
        margin-bottom: 24px;
        order: 1;
      }
      .title {
        order: 2;
        padding: 0 16px;
        margin-bottom: 24px;
        .h1 {
          font-size: 38px;
          line-height: 40px;
          font-weight: 500;
        }
      }
      .text {
        padding: 0 16px;
        order: 5;
        .h3 {
          margin-bottom: 8px;
        }
        p {
          margin: 0 0 24px 0;
        }
      }
      .control {
        margin: 0 16px 24px;
        order: 6;
        .button {
          width: 100%;
        }
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    margin: 0;
    padding: 90px 0 168px 0 !important;
    .container {
      position: relative;
      .content {
        position: relative;
        z-index: 10;
        // margin-top: -240px;
        // padding-top: 240px;
        display: flex;
        //height: 800px;
        justify-content: flex-start;
        flex-wrap: wrap;
        flex-direction: column;
        .head {
          order: 1;
          padding: 0 100px 0 0;
          .button {
            display: inline-flex;
          }
        }
        .title {
          order: 2;
          //width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          //margin-bottom: 16px;
          .h1 {
            font-size: 54px;
            line-height: 60px;
            font-weight: 500;
          }
        }
        .text {
          order: 4;
          //width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          margin-bottom: 24px;
          p {
            margin: 0 0 16px 0;
          }
        }
        .control {
          order: 5;
          //width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          margin: 0;
          .button {
            width: auto;
          }
        }
      }
    }
  }
}
</style>
